var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.isShowingCreateFolderModal)?_c('folder-create-modal'):_vm._e(),_c('folders-all-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }